import { useNavigate } from 'react-router-dom'

import { Wizard } from '@factorialco/deprecated-design-system'
import { BudgetLegalEntityFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/finance/lib/newBudgetWizard'

import { basicDetailsStep } from './BasicDetails'
import { budgetAccessStep } from './BudgetAccess'
import { budgetLimitsStep } from './BudgetLimits'
import { spendersStep } from './Spenders'

interface Props {
  onSuccess: (budgetId: number) => void
  onError: () => void
  legalEntities: BudgetLegalEntityFragment[]
}

export const NewBudgetWizard = ({ onSuccess, onError, legalEntities }: Props) => {
  const session = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const mainLegalEntity = legalEntities?.find((node) => node.main == true)
  const initialData: WizardData = {
    legalEntityId: mainLegalEntity?.id,
    legalEntities: legalEntities,
    success: false,
    name: '',
    description: '',
    ownerEmployeeIds: [session.employee.id],
    viewerEmployeeIds: [],
    spenders: [],
    effectiveFrom: '',
    amountCents: '',
    currency: mainLegalEntity?.currency ?? '',
    errors: {},
    allocationType: 'none',
    allocatedAmountCents: '',
  }

  const handleSubmit = async (data: WizardData) => {
    data.success && data.budgetId ? onSuccess(data.budgetId) : onError()
  }

  return (
    <Wizard.Modal
      size="large"
      onClose={() => {
        navigate(navigation.expenses.budgets.fullPath())
      }}
      title={i18n.t('budgets.forms.new_budget.title')}
      description={i18n.t('budgets.forms.new_budget.description')}
      icon="money-bag"
      steps={[basicDetailsStep(), budgetAccessStep(), budgetLimitsStep(), spendersStep()]}
      initialData={initialData}
      onSubmit={handleSubmit}
    />
  )
}
